// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../..//../public/images/app-home/sec2/slick-prev.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../..//../public/images/app-home/sec2/slick-next-3.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bloghome.slider-outer .row.sec-title {
  display: flex !important;
  align-items: center; 
  height: 410px;
  padding-left: 3rem;
  
}
/* .bloghome.slider-outer .slick-slider{
  padding-left: 3%;
} */

.row.sec-title .yellow-line{
  font-family: Poppins;
  font-size: 38px ;
  font-weight: 700 ;
  line-height: 48px;
}
.bloghome.slider-outer h5{
  font-size: 23px;
  font-weight: 700;
  line-height: 28px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
.bloghome.slider-outer {
  margin: 0 auto;
  /* margin-bottom: 2rem; */
  width: 100%;
  height: fit-content;
  font-family: Poppins;
  padding-left: 0;
  padding-top: 2.5rem;
  padding-bottom: 8rem;
}
.bloghome.slider-outer .slick-slide {
  text-align: center;
  width: 316px;
  height: 80vh;
  transition: .7s ease;
}

.bloghome.slider-outer .slick-slide:first-child {
  width: 500px; /* Adjust the width for the first slide */
}
.bloghome.slider-outer .slick-slide:hover {
  width: 316px;
  transition: .7s ease;
}
.bloghome.slider-outer .slide:hover .slick-slide:not(:hover) {
  transition: .7s ease;
}


.bloghome.slider-outer .blogcard{
  width: 280px; 
  height: 480px; 
  margin-top: 50px;
  border: none;
  position: relative;
  transition: all 1s ease;
  
  
  
}
.bloghome.slider-outer .blogcard-img-top{
  width: 100%;
  height: 330px; 
  object-fit: cover; 
  transition: all 1s ease;
  
}
.bloghome.slider-outer .blogcard-body{
  padding: 20px;
  text-align: start;
  background: #fff;
  transition: all 1s ease;
}
.bloghome.slider-outer .blogcard:hover .blogcard-img-top{
  height: 370px;
  position: relative;
  transition: all 1s ease;
  box-shadow: 0px -4px 8px rgba(0, 0, 0, 0.2);

}
.bloghome.slider-outer .blogcard:hover  {
  transform: translateY(-20px);
  transition: all 1s ease; 
  /* box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2); */
}
.bloghome.slider-outer .blogcard:hover .blogcard-body{

  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2);
}

.blogcard-desc{
  font-size: 16px;
  font-weight: 300;
  line-height: 24px;
}
.blogcard-title{
  padding-top: 10px;
  padding-bottom: 10px;
  text-transform: none;
}

.blogcard-title,
  .blogcard-text {
      margin: 0;
  }

  .home-sec-5 .slick-next::before, .home-sec-5 .slick-prev::before{
      margin: 0 ;
      
      
  }

  .home-sec-5 .slick-next{
      position: absolute;
      top: calc(110% - 20px);
      left: 51%;
      transform: translateX(-50%); 
      font-size: 0;
      right: 14rem;
      font-size: 0 !important;
  }

  .home-sec-5 .slick-prev{
      position: absolute;
      top: calc(110% - 20px);
      left:46%;
      transform: translateX(-50%); 
      font-size: 0 !important;
  }
  .home-sec-5 .slick-prev::before{
      content: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  }
  .home-sec-5 .slick-next::before{
      content: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  }
  

  .bloghome.slider-outer .slick-slide {
    height: fit-content;
  }

  @media (min-width:768px) and (max-width:992px) {
    .home-sec-5 .row.sec-title .yellow-line {
      width: 92%;
    }
    .asia.home-sec-5 .row.sec-title .yellow-line {
      width: 92%;
    }
    .home-sec-5 .slick-prev{
      left: 43%;
    }
    .bloghome.slider-outer .blogcard {
      width: 288px;
    }
    /* .bloghome.slider-outer .slick-slide {
      width: 305px !important;
    } */
    .bloghome.slider-outer{
      height: 70vh;
    }
    /* .row.sec-title ,.row.sec-title .yellow-line{
      display: none !important;
      width: 0;
    } */
    
  }

@media (max-width:576px){
  .bloghome.slider-outer .slick-slide {
    padding-left: 5px;
  }
  .bloghome.slider-outer{
    height: fit-content;
    padding-bottom: 7rem;
    padding-top: 0;
    margin-top: -1rem;
  }
  .row.sec-titlelg-title,.row.sec-title.lg-title .yellow-line {
    display: none !important;
    width: 0 !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/common-componets/Home/HomeBlogSlider.css"],"names":[],"mappings":"AAAA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,aAAa;EACb,kBAAkB;;AAEpB;AACA;;GAEG;;AAEH;EACE,oBAAoB;EACpB,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,cAAc;EACd,yBAAyB;EACzB,WAAW;EACX,mBAAmB;EACnB,oBAAoB;EACpB,eAAe;EACf,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,YAAY,EAAE,yCAAyC;AACzD;AACA;EACE,YAAY;EACZ,oBAAoB;AACtB;AACA;EACE,oBAAoB;AACtB;;;AAGA;EACE,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;;;;AAIzB;AACA;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,uBAAuB;;AAEzB;AACA;EACE,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,uBAAuB;EACvB,2CAA2C;;AAE7C;AACA;EACE,4BAA4B;EAC5B,uBAAuB;EACvB,gDAAgD;AAClD;AACA;;EAEE,0CAA0C;AAC5C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,oBAAoB;AACtB;;AAEA;;MAEM,SAAS;EACb;;EAEA;MACI,UAAU;;;EAGd;;EAEA;MACI,kBAAkB;MAClB,sBAAsB;MACtB,SAAS;MACT,2BAA2B;MAC3B,YAAY;MACZ,YAAY;MACZ,uBAAuB;EAC3B;;EAEA;MACI,kBAAkB;MAClB,sBAAsB;MACtB,QAAQ;MACR,2BAA2B;MAC3B,uBAAuB;EAC3B;EACA;MACI,gDAAkE;EACtE;EACA;MACI,gDAAoE;EACxE;;;EAGA;IACE,mBAAmB;EACrB;;EAEA;IACE;MACE,UAAU;IACZ;IACA;MACE,UAAU;IACZ;IACA;MACE,SAAS;IACX;IACA;MACE,YAAY;IACd;IACA;;OAEG;IACH;MACE,YAAY;IACd;IACA;;;OAGG;;EAEL;;AAEF;EACE;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;IACnB,oBAAoB;IACpB,cAAc;IACd,iBAAiB;EACnB;EACA;IACE,wBAAwB;IACxB,mBAAmB;EACrB;AACF","sourcesContent":[".bloghome.slider-outer .row.sec-title {\r\n  display: flex !important;\r\n  align-items: center; \r\n  height: 410px;\r\n  padding-left: 3rem;\r\n  \r\n}\r\n/* .bloghome.slider-outer .slick-slider{\r\n  padding-left: 3%;\r\n} */\r\n\r\n.row.sec-title .yellow-line{\r\n  font-family: Poppins;\r\n  font-size: 38px ;\r\n  font-weight: 700 ;\r\n  line-height: 48px;\r\n}\r\n.bloghome.slider-outer h5{\r\n  font-size: 23px;\r\n  font-weight: 700;\r\n  line-height: 28px;\r\n  display: -webkit-box;\r\n  -webkit-line-clamp: 2;\r\n  -webkit-box-orient: vertical;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n}\r\n.bloghome.slider-outer {\r\n  margin: 0 auto;\r\n  /* margin-bottom: 2rem; */\r\n  width: 100%;\r\n  height: fit-content;\r\n  font-family: Poppins;\r\n  padding-left: 0;\r\n  padding-top: 2.5rem;\r\n  padding-bottom: 8rem;\r\n}\r\n.bloghome.slider-outer .slick-slide {\r\n  text-align: center;\r\n  width: 316px;\r\n  height: 80vh;\r\n  transition: .7s ease;\r\n}\r\n\r\n.bloghome.slider-outer .slick-slide:first-child {\r\n  width: 500px; /* Adjust the width for the first slide */\r\n}\r\n.bloghome.slider-outer .slick-slide:hover {\r\n  width: 316px;\r\n  transition: .7s ease;\r\n}\r\n.bloghome.slider-outer .slide:hover .slick-slide:not(:hover) {\r\n  transition: .7s ease;\r\n}\r\n\r\n\r\n.bloghome.slider-outer .blogcard{\r\n  width: 280px; \r\n  height: 480px; \r\n  margin-top: 50px;\r\n  border: none;\r\n  position: relative;\r\n  transition: all 1s ease;\r\n  \r\n  \r\n  \r\n}\r\n.bloghome.slider-outer .blogcard-img-top{\r\n  width: 100%;\r\n  height: 330px; \r\n  object-fit: cover; \r\n  transition: all 1s ease;\r\n  \r\n}\r\n.bloghome.slider-outer .blogcard-body{\r\n  padding: 20px;\r\n  text-align: start;\r\n  background: #fff;\r\n  transition: all 1s ease;\r\n}\r\n.bloghome.slider-outer .blogcard:hover .blogcard-img-top{\r\n  height: 370px;\r\n  position: relative;\r\n  transition: all 1s ease;\r\n  box-shadow: 0px -4px 8px rgba(0, 0, 0, 0.2);\r\n\r\n}\r\n.bloghome.slider-outer .blogcard:hover  {\r\n  transform: translateY(-20px);\r\n  transition: all 1s ease; \r\n  /* box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2); */\r\n}\r\n.bloghome.slider-outer .blogcard:hover .blogcard-body{\r\n\r\n  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2);\r\n}\r\n\r\n.blogcard-desc{\r\n  font-size: 16px;\r\n  font-weight: 300;\r\n  line-height: 24px;\r\n}\r\n.blogcard-title{\r\n  padding-top: 10px;\r\n  padding-bottom: 10px;\r\n  text-transform: none;\r\n}\r\n\r\n.blogcard-title,\r\n  .blogcard-text {\r\n      margin: 0;\r\n  }\r\n\r\n  .home-sec-5 .slick-next::before, .home-sec-5 .slick-prev::before{\r\n      margin: 0 ;\r\n      \r\n      \r\n  }\r\n\r\n  .home-sec-5 .slick-next{\r\n      position: absolute;\r\n      top: calc(110% - 20px);\r\n      left: 51%;\r\n      transform: translateX(-50%); \r\n      font-size: 0;\r\n      right: 14rem;\r\n      font-size: 0 !important;\r\n  }\r\n\r\n  .home-sec-5 .slick-prev{\r\n      position: absolute;\r\n      top: calc(110% - 20px);\r\n      left:46%;\r\n      transform: translateX(-50%); \r\n      font-size: 0 !important;\r\n  }\r\n  .home-sec-5 .slick-prev::before{\r\n      content: url(../..//../public/images/app-home/sec2/slick-prev.svg);\r\n  }\r\n  .home-sec-5 .slick-next::before{\r\n      content: url(../..//../public/images/app-home/sec2/slick-next-3.svg);\r\n  }\r\n  \r\n\r\n  .bloghome.slider-outer .slick-slide {\r\n    height: fit-content;\r\n  }\r\n\r\n  @media (min-width:768px) and (max-width:992px) {\r\n    .home-sec-5 .row.sec-title .yellow-line {\r\n      width: 92%;\r\n    }\r\n    .asia.home-sec-5 .row.sec-title .yellow-line {\r\n      width: 92%;\r\n    }\r\n    .home-sec-5 .slick-prev{\r\n      left: 43%;\r\n    }\r\n    .bloghome.slider-outer .blogcard {\r\n      width: 288px;\r\n    }\r\n    /* .bloghome.slider-outer .slick-slide {\r\n      width: 305px !important;\r\n    } */\r\n    .bloghome.slider-outer{\r\n      height: 70vh;\r\n    }\r\n    /* .row.sec-title ,.row.sec-title .yellow-line{\r\n      display: none !important;\r\n      width: 0;\r\n    } */\r\n    \r\n  }\r\n\r\n@media (max-width:576px){\r\n  .bloghome.slider-outer .slick-slide {\r\n    padding-left: 5px;\r\n  }\r\n  .bloghome.slider-outer{\r\n    height: fit-content;\r\n    padding-bottom: 7rem;\r\n    padding-top: 0;\r\n    margin-top: -1rem;\r\n  }\r\n  .row.sec-titlelg-title,.row.sec-title.lg-title .yellow-line {\r\n    display: none !important;\r\n    width: 0 !important;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
